export default function MostReadList({ title, total }) {
  return (
    <div className="py-2.5 border-b border-white-200 last:border-b-0 flex items-center">
      <span className="flex-1 text-sm text-black-200">{title}</span>
      <span className="text-sm font-semibold text-primary-600 bg-primary-50 px-2 py-0.5 rounded">
        {total}
      </span>
    </div>
  );
}
